import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Alert } from '../components/ui';
import CreditBalanceWidget from '../components/CreditBalanceWidget';
import CreditTransactionHistory from '../components/CreditTransactionHistory';
import { trialDashboardService } from '../services/trial-dashboard.service';

export default function ManufacturerCreditManagementPage() {
  const navigate = useNavigate();
  const [isTrialAccount, setIsTrialAccount] = useState(false);
  const [loadingTrial, setLoadingTrial] = useState(true);
  const [trialError, setTrialError] = useState<string | null>(null);

  useEffect(() => {
    const detectTrialStatus = async () => {
      try {
        setLoadingTrial(true);
        const status = await trialDashboardService.getTrialStatus();
        setIsTrialAccount(status.isTrial);
        setTrialError(null);
      } catch (error) {
        console.error('Failed to detect trial status:', error);
        setIsTrialAccount(false);
        setTrialError('Unable to detect trial status. Showing standard credit actions.');
      } finally {
        setLoadingTrial(false);
      }
    };

    void detectTrialStatus();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Credit Management</h1>
          <p className="text-sm text-gray-600 mt-1">
            Monitor balance, review transaction history, and manage credit top-ups.
          </p>
        </div>
        <Button variant="outline" onClick={() => navigate('/manufacturer')}>
          Back to Dashboard
        </Button>
      </div>

      {trialError && (
        <Alert variant="error" className="mb-6">
          {trialError}
        </Alert>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        <div className="space-y-4">
          <CreditBalanceWidget />

          {!loadingTrial && isTrialAccount && (
            <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-xs text-blue-800">
              Trial credits are preloaded. Top-ups are disabled until full registration is approved.
            </div>
          )}

          {!loadingTrial && !isTrialAccount && (
            <div className="bg-white rounded-lg shadow p-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-3">Payment Gateway</h3>
              <Button
                fullWidth
                onClick={() => navigate('/manufacturer/payment')}
                className="flex items-center justify-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Add Credits
              </Button>
              <p className="text-xs text-gray-500 mt-2 text-center">
                UPI, Cards, Net Banking & Bank Transfer
              </p>
            </div>
          )}
        </div>

        <div className="lg:col-span-2">
          <CreditTransactionHistory />
        </div>
      </div>
    </div>
  );
}
